import { render, staticRenderFns } from "./HomepageConfig.vue?vue&type=template&id=2adf2f36&"
import script from "./HomepageConfig.vue?vue&type=script&lang=js&"
export * from "./HomepageConfig.vue?vue&type=script&lang=js&"
import style0 from "./HomepageConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports